import React, { Component } from 'react'
import BackdropPickerDialog    from './dialogs/BackdropPickerDialog'
import PerformancePickerDialog from './dialogs/PerformancePickerDialog'
import Translation from '../../Translation/cont/Translation'
import TranslationTime from '../../Translation/cont/TranslationTime'
import TranslationShowtime from '../../Translation/cont/TranslationShowtime'
import getTranslationStringById from '../../Translation/func/getTranslationStringById'
import SearchInput from '../../general/SearchInput'
import ImageUpload from '../../forms/fields/ImagesGeneral/ImageUpload'

class ImageSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showBackdropPicker:    false,
            showPerformancePicker: false,
            movieSearch:           '',
        }
    }

    getMovieEntries() {
        const { movies } = this.props
        if (!movies) return []
        return Array.isArray(movies)
            ? movies.map((m, i) => [String(i), m])
            : Object.entries(movies)
    }

    getMovieOptions() {
        const search = this.state.movieSearch.toLowerCase()
        return this.getMovieEntries()
            .filter(([, m]) => !search || ((m.titleDisplay || m.title) || '').toLowerCase().includes(search))
            .slice(0, 50)
    }

    getSelectedMovie() {
        const { movies, image } = this.props
        if (!movies || !image.movieId) return null
        if (Array.isArray(movies)) {
            return movies.find(m => String(m.id || m.pk) === String(image.movieId)) || null
        }
        return movies[image.movieId] || null
    }

    getMovieBackdrops() {
        const movie = this.getSelectedMovie()
        if (!movie) return []
        return (movie.images && movie.images.backgrounds) || []
    }

    getSelectedPerformance() {
        const { performances, image } = this.props
        if (!performances || !image.performanceId) return null
        const list = Array.isArray(performances) ? performances : Object.values(performances)
        return list.find(p => String(p.id || p.pk) === String(image.performanceId)) || null
    }

    render() {
        const { image, formats, formatId, customWidth, customHeight,
                onFormatChange, onImageChange, onCustomWidthChange, onCustomHeightChange,
                performances, cinemas, presets, onPresetChange, preset, slideTabs,
                translationStrings, currentLang, translationDebug } = this.props
        const { showBackdropPicker, showPerformancePicker, movieSearch } = this.state
        const selectMovieLabel = getTranslationStringById('select_movie_button', translationStrings, currentLang, '—', translationDebug)
        const movieOptions  = this.getMovieOptions()
        const selectedMovie = this.getSelectedMovie()
        const posterUrl     = selectedMovie && selectedMovie.images && selectedMovie.images.poster
            ? selectedMovie.images.poster.url : null
        const selectedPerf       = this.getSelectedPerformance()
        const selectedTheaterName = selectedPerf ? selectedPerf.theatreName : null

        return (
            <div className="image-settings">

                {/* Format + Preset */}
                <div className="image-settings__section">
                    <div className="image-settings__section-title text-small-bold"><Translation id="social_media_section_format" /></div>
                    <select className="select-box" value={formatId} onChange={e => onFormatChange(e.target.value)}>
                        {formats.map(f => <option key={f.id} value={f.id}>{f.label}</option>)}
                    </select>
                    {formatId === 'custom' && (
                        <div className="image-settings__row">
                            <div className="image-settings__field">
                                <label className="field-label-small text-small-regular"><Translation id="social_media_width_px" /></label>
                                <input type="number" className="input-text-box input-text-box--short"
                                    value={customWidth}
                                    onChange={e => onCustomWidthChange(parseInt(e.target.value, 10))} />
                            </div>
                            <div className="image-settings__field">
                                <label className="field-label-small text-small-regular"><Translation id="social_media_height_px" /></label>
                                <input type="number" className="input-text-box input-text-box--short"
                                    value={customHeight}
                                    onChange={e => onCustomHeightChange(parseInt(e.target.value, 10))} />
                            </div>
                        </div>
                    )}
                    {presets && presets.length > 0 && (
                        <select className="select-box" style={{ marginTop: 6 }}
                            value={image.presetId || (preset ? preset.id : '') || ''}
                            onChange={e => onPresetChange && onPresetChange(e.target.value)}>
                            {presets.map(p => (
                                <option key={p.id} value={p.id}>{p.name}</option>
                            ))}
                        </select>
                    )}
                </div>

                {slideTabs}

                {/* Movie */}
                <div className="image-settings__section">
                    <div className="image-settings__section-title text-small-bold"><Translation id="social_media_section_movie" /></div>
                    <SearchInput
                        placeholderTransId="social_media_search_movie_placeholder"
                        value={movieSearch}
                        onChange={val => this.setState({ movieSearch: val })}
                    />
                    <select className="select-box" value={image.movieId || ''}
                        onChange={e => onImageChange({ movieId: e.target.value || null })}>
                        <option value="">{selectMovieLabel}</option>
                        {movieOptions.map(([pk, m]) => (
                            <option key={pk} value={pk}>{m.titleDisplay || m.title || pk}</option>
                        ))}
                    </select>
                </div>

                {/* Image */}
                <div className="image-settings__section">
                    <div className="image-settings__section-title text-small-bold"><Translation id="social_media_section_image" /></div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="tmdb_conflict_poster_label" /></label>
                        <div className="image-settings__poster-preview">
                            {posterUrl && <img src={posterUrl} alt="" />}
                        </div>
                        <input type="checkbox" className="tgl tgl-flat" id="poster-enabled"
                            checked={image.posterEnabled}
                            onChange={e => onImageChange({ posterEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="poster-enabled"></label>
                    </div>
                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="social_media_gradient_overlay" /></label>
                        <input type="checkbox" className="tgl tgl-flat" id="gradientEnabled"
                            checked={image.gradientEnabled}
                            onChange={e => onImageChange({ gradientEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="gradientEnabled"></label>
                    </div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="social_media_backdrop" /></label>
                        <input type="checkbox" className="tgl tgl-flat" id="backdrop-enabled"
                            checked={image.backdropEnabled}
                            onChange={e => onImageChange({ backdropEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="backdrop-enabled"></label>
                    </div>
                    {image.backdropEnabled && (
                        <div className="image-settings__field">
                            <div className="radio-group">
                                <label className="radio-label text-small-bold">
                                    <input type="radio" name="backdrop-source" value="movie"
                                        checked={image.backdropSource === 'movie'}
                                        disabled={!image.movieId}
                                        onChange={() => onImageChange({ backdropSource: 'movie' })} />
                                    <Translation id="social_media_from_movie" />
                                </label>
                                <label className="radio-label text-small-bold">
                                    <input type="radio" name="backdrop-source" value="upload"
                                        checked={image.backdropSource === 'upload'}
                                        onChange={() => onImageChange({ backdropSource: 'upload' })} />
                                    <Translation id="social_media_upload" />
                                </label>
                            </div>
                            {image.backdropSource === 'movie' && (
                                <>
                                    <button className="button button-theme"
                                        disabled={!image.movieId}
                                        onClick={() => this.setState({ showBackdropPicker: true })}>
                                        {image.backdropUrl
                                            ? <Translation id="social_media_change_backdrop" />
                                            : <Translation id="social_media_select_backdrop" />}
                                    </button>
                                    {image.backdropUrl && (
                                        <div className="image-settings__picker-selected">
                                            <div className="image-settings__picker-selected-img">
                                                <img src={image.backdropUrl} alt="" />
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                            {image.backdropSource === 'upload' && (
                                image.backdropUrl ? (
                                    <div className="image-settings__picker-selected">
                                        <div className="image-settings__picker-selected-img">
                                            <img src={image.backdropUrl} alt="" />
                                        </div>
                                        <button type="button" className="button button--small"
                                            onClick={() => onImageChange({ backdropUrl: null })}>
                                            <Translation id="remove_button" />
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        <button type="button" className="button button-theme"
                                            onClick={() => this.backdropUploadInput.click()}>
                                            <Translation id="social_media_upload" />
                                        </button>
                                        <input type="file" accept="image/*"
                                            ref={el => this.backdropUploadInput = el}
                                            style={{ display: 'none' }}
                                            onChange={e => {
                                                const file = e.target.files[0]
                                                if (!file) return
                                                const reader = new FileReader()
                                                reader.onload = ev => onImageChange({ backdropUrl: ev.target.result })
                                                reader.readAsDataURL(file)
                                            }} />
                                    </>
                                )
                            )}
                        </div>
                    )}
                </div>

                {/* Text */}
                <div className="image-settings__section">
                    <div className="image-settings__section-title text-small-bold"><Translation id="social_media_section_text" /></div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="advertisement_title" /></label>
                        <input type="text" className="image-settings__tgl-field"
                            placeholder="Titel..."
                            value={image.titleText}
                            onChange={e => onImageChange({ titleText: e.target.value })} />
                        <input type="checkbox" className="tgl tgl-flat" id="title-enabled"
                            checked={image.titleEnabled}
                            onChange={e => onImageChange({ titleEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="title-enabled"></label>
                    </div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="social_media_free_text" /></label>
                        <input type="text" className="image-settings__tgl-field"
                            placeholder="Freitext..."
                            value={image.freetextText}
                            onChange={e => onImageChange({ freetextText: e.target.value })} />
                        <input type="checkbox" className="tgl tgl-flat" id="freetext-enabled"
                            checked={image.freetextEnabled}
                            onChange={e => onImageChange({ freetextEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="freetext-enabled"></label>
                    </div>
                </div>

                {/* Date/Time */}
                <div className="image-settings__section">
                    <div className="image-settings__section-title text-small-bold"><Translation id="social_media_section_datetime" /></div>
                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="advertisement_active" /></label>
                        <input type="checkbox" className="tgl tgl-flat" id="date-enabled"
                            checked={image.dateEnabled}
                            onChange={e => onImageChange({ dateEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="date-enabled"></label>
                    </div>
                    {image.dateEnabled && (
                        <div className='image-settings__field'>
                            <div className="radio-group">
                                <label className="radio-label text-small-bold">
                                    <input type="radio" name="date-mode" value="manual"
                                        checked={image.dateMode === 'manual'}
                                        onChange={() => onImageChange({ dateMode: 'manual' })} />
                                    <Translation id="social_media_manual" />
                                </label>
                                <label className="radio-label text-small-bold">
                                    <input type="radio" name="date-mode" value="performance"
                                        checked={image.dateMode === 'performance'}
                                        disabled={!image.movieId}
                                        onChange={() => onImageChange({ dateMode: 'performance' })} />
                                    <Translation id="social_media_from_performance" />
                                </label>
                            </div>
                            {image.dateMode === 'manual' && (
                                <input type="text" className="input-text-box"
                                    placeholder="z.B. 02.04 20:15 Uhr"
                                    value={image.dateManual}
                                    onChange={e => onImageChange({ dateManual: e.target.value })} />
                            )}
                            {image.dateMode === 'performance' && (
                                <>
                                    <button className="button button-theme"
                                        disabled={!image.movieId}
                                        onClick={() => this.setState({ showPerformancePicker: true })}>
                                        {image.performanceId
                                            ? <Translation id="social_media_change_performance" />
                                            : <Translation id="social_media_select_performance" />}
                                    </button>
                                    {selectedPerf && (
                                        <div className="image-settings__picker-selected">
                                            <div>
                                                <div className="image-settings__picker-selected-date">
                                                    <TranslationTime id="dateWithDay" timeString={selectedPerf.timeUtc} />
                                                </div>
                                                <div className="image-settings__picker-selected-time">
                                                    <TranslationShowtime string={selectedPerf.timeUtc} />
                                                    {selectedTheaterName && ` · ${selectedTheaterName}`}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>

                {/* Extras */}
                <div className="image-settings__section">
                    <div className="image-settings__section-title text-small-bold"><Translation id="social_media_section_extras" /></div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="social_media_border" /></label>
                        <input type="checkbox" className="tgl tgl-flat" id="borderEnabled"
                            checked={image.borderEnabled}
                            onChange={e => onImageChange({ borderEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="borderEnabled"></label>
                    </div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="social_media_stoerer" /></label>
                        <input type="text" className="image-settings__tgl-field"
                            placeholder="Badge-Text..."
                            value={image.badgeText}
                            onChange={e => onImageChange({ badgeText: e.target.value })} />
                        <input type="checkbox" className="tgl tgl-flat" id="badgeEnabled"
                            checked={image.badgeEnabled}
                            onChange={e => onImageChange({ badgeEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="badgeEnabled"></label>
                    </div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="social_media_rating_badge" /></label>
                        <input type="checkbox" className="tgl tgl-flat" id="fskEnabled"
                            checked={image.fskEnabled}
                            onChange={e => onImageChange({ fskEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="fskEnabled"></label>
                    </div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="social_media_cta" /></label>
                        <input type="text" className="image-settings__tgl-field"
                            placeholder="CTA-Text..."
                            value={image.ctaText}
                            onChange={e => onImageChange({ ctaText: e.target.value })} />
                        <input type="checkbox" className="tgl tgl-flat" id="ctaEnabled"
                            checked={image.ctaEnabled}
                            onChange={e => onImageChange({ ctaEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="ctaEnabled"></label>
                    </div>

                    <div className="image-settings__toggle-row">
                        <label className="field-label-small text-small-regular"><Translation id="logo" /></label>
                        <input type="checkbox" className="tgl tgl-flat" id="logoEnabled"
                            checked={image.logoEnabled}
                            onChange={e => onImageChange({ logoEnabled: e.target.checked })} />
                        <label className="tgl-btn" htmlFor="logoEnabled"></label>
                    </div>
                    {image.logoEnabled && (
                        <div className="image-settings__field">
                            <label className="field-label-small text-small-regular"><Translation id="social_media_upload_logo" /></label>
                            {image.logoOverrideUrl ? (
                                <div className="image-settings__picker-selected">
                                    <div className="image-settings__picker-selected-img">
                                        <img src={image.logoOverrideUrl} alt="" />
                                    </div>
                                    <button type="button" className="button button--small"
                                        onClick={() => onImageChange({ logoOverrideUrl: null })}>
                                        <Translation id="remove_button" />
                                    </button>
                                </div>
                            ) : (
                                <ImageUpload
                                    autoUpload={true}
                                    hideAdditionalText={true}
                                    onUploadStart={() => {}}
                                    onUploadEndSuccess={data => onImageChange({ logoOverrideUrl: data.source_url })}
                                    onUploadEndError={() => {}}
                                />
                            )}
                        </div>
                    )}
                </div>

                {showBackdropPicker && (
                    <BackdropPickerDialog
                        backdrops={this.getMovieBackdrops()}
                        selectedUrl={image.backdropUrl}
                        onSelect={url => {
                            onImageChange({ backdropUrl: url })
                            this.setState({ showBackdropPicker: false })
                        }}
                        onCancel={() => this.setState({ showBackdropPicker: false })}
                    />
                )}
                {showPerformancePicker && (
                    <PerformancePickerDialog
                        performances={performances}
                        cinemas={cinemas}
                        movieId={image.movieId}
                        selectedId={image.performanceId}
                        onSelect={id => {
                            onImageChange({ performanceId: id })
                            this.setState({ showPerformancePicker: false })
                        }}
                        onCancel={() => this.setState({ showPerformancePicker: false })}
                    />
                )}
            </div>
        )
    }
}

export default ImageSettings
